// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Q8xcw","pdf":"styles_pdf__rkwto"};